import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks';
import type { OverviewCategory } from 'shared/src/api';

export const useLogClickExpandableCategoryList = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(
    (category: OverviewCategory) => {
      // native(Android `toCategoryTabList`, iOS `OverviewCategoryGroup.logging`)와
      // 동일하게 그룹 logging이 있으면 우선 사용.
      const analytics =
        category.item.index?.logging.analytics ?? category.logging.analytics;
      logAnalyticsEvent({
        name: 'CLICK_EXPANDABLE_CATEGORY_LIST',
        analytics: { ...analytics },
      });
    },
    [logAnalyticsEvent],
  );
};
